import { ItiBaseDto } from '@/iti-core-vue';

export class LerCode extends ItiBaseDto {
    public code !: string;
    public description !: string;
}